
import axios from 'axios';
import Constants from '@/plugins/constants';

// درخواست‌های عادی برنامه
export const apiClient_New = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// درخواست‌های بازیابی؛ بدون Interceptor
export const recoveryClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

let recoverySetupDone = false;
let refreshPromise = null;

export function setupApiInterceptors(store, router) {
  if (recoverySetupDone) return;
  recoverySetupDone = true;

  apiClient_New.interceptors.request.use((config) => {
    config.headers = config.headers || {};

    const csrf = store.state.loginModule?.csrf;

    if (csrf) {
      config.headers['X-CSRF-Token'] = csrf;
    }

    return config;
  });

  apiClient_New.interceptors.response.use(
    (response) => response,

    async (error) => {
      const config = error.config;
      const status = error.response?.status;

      if (!config || !status) {
        return Promise.reject(error);
      }

      // خطای 400 فقط یک بار در هر زنجیره‌ی بازیابی
      // و با سقف دو بار دریافت CSRF
      config._csrfRetryCount = config._csrfRetryCount || 0;
      config._refreshRetried = config._refreshRetried || false;

      const getCsrf = () =>
        store.dispatch('loginModule/csrf');

      const refreshToken = () => {
        if (!refreshPromise) {
          refreshPromise = store
            .dispatch('userModule/refreshToken')
            .finally(() => {
              refreshPromise = null;
            });
        }

        return refreshPromise;
      };

      const logout = async () => {
        if (!config._logoutRedirected) {
          config._logoutRedirected = true;

          if (router.currentRoute.name !== 'login') {
            await router.replace({ name: 'login' });
          }
        }

        return Promise.reject(error);
      };

      if (status === 401) {
        if (config._refreshRetried) {
          return logout();
        }

        config._refreshRetried = true;

        try {
          await refreshToken();
          await getCsrf();

          config._csrfRetryCount += 1;

          return apiClient_New(config);
        } catch (recoveryError) {
          if (recoveryError.response?.status === 401) {
            return logout();
          }

          return Promise.reject(recoveryError);
        }
      }

      if (status === 400) {
        if (config._csrfRetryCount >= 2) {
          return Promise.reject(error);
        }

        try {
          await getCsrf();
          config._csrfRetryCount += 1;

          return apiClient_New(config);
        } catch (csrfError) {
          if (csrfError.response?.status === 401) {
            if (config._refreshRetried) {
              return logout();
            }

            config._refreshRetried = true;

            try {
              await refreshToken();
              await getCsrf();

              config._csrfRetryCount += 1;

              return apiClient_New(config);
            } catch (refreshError) {
              if (refreshError.response?.status === 401) {
                return logout();
              }

              return Promise.reject(refreshError);
            }
          }

          return Promise.reject(csrfError);
        }
      }

      return Promise.reject(error);
    }
  );
}
